import React, { useState, useMemo } from 'react';
import ZohoDeskModal from '../components/integrations/ZohoDeskModal';
import DeskProModal from '../components/integrations/DeskProModal';
import HubSpotModal from '../components/integrations/HubSpotModal';
import SalesforceModal from '../components/integrations/SalesforceModal';
import ChattitudeModal from '../components/integrations/ChattitudeModal';
import StatusIoModal from '../components/integrations/StatusIoModal';
import CalcomModal from '../components/integrations/CalcomModal';
import Cookies from 'js-cookie';
import { useReseller } from '../contexts/ResellerContext';
import { getIntegrations } from '../common/toolCatalog';


const cardStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #e0e0e0',
  borderRadius: 12,
  padding: 32,
  width: 260,
  margin: 16,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  background: '#fff',
};

const cardsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginTop: 32,
};

const Tools = () => {
  const { reseller } = useReseller();
  const productName = reseller?.productName || 'Chattitude';
  const integrations = useMemo(() => getIntegrations(productName, reseller), [productName, reseller]);
  const [modalOpen, setModalOpen] = useState(false);
  const [deskproModalOpen, setDeskproModalOpen] = useState(false);
  const [hubspotModalOpen, setHubspotModalOpen] = useState(false);
  const [salesforceModalOpen, setSalesforceModalOpen] = useState(false);
  const [chattitudeModalOpen, setChattitudeModalOpen] = useState(false);
  const [statusIoModalOpen, setStatusIoModalOpen] = useState(false);
  const [calcomModalOpen, setCalcomModalOpen] = useState(false);
  const [currentProvider, setCurrentProvider] = useState(null);
  const tenantId = Cookies.get('tenantId');

  const handleSettings = (provider) => {
    if (provider === 'zohodesk') {
      setCurrentProvider('zohodesk');
      setModalOpen(true);
    }
    if (provider === 'hubspot') {
      setCurrentProvider('hubspot');
      setHubspotModalOpen(true);
    }
    if (provider === 'deskpro') {
      setCurrentProvider('deskpro');
      setDeskproModalOpen(true);
    }
    if (provider === 'chattitude') {
      setCurrentProvider('chattitude');
      setChattitudeModalOpen(true);
    }
    if (provider === 'salesforce') {
      setCurrentProvider('salesforce');
      setSalesforceModalOpen(true);
    }
    if (provider === 'statusio') {
      setCurrentProvider('statusio');
      setStatusIoModalOpen(true);
    }
    if (provider === 'calcom') {
      setCurrentProvider('calcom');
      setCalcomModalOpen(true);
    }
  };

  return (
    <div style={{ padding: 32 }}>
      <h2 style={{ textAlign: 'center' }}>Tools & Integrations</h2>
      <div style={cardsContainerStyle}>
        {integrations.map((integration) => (
          <div key={integration.name} style={cardStyle}>
            <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 12 }}>{integration.name}</div>
            <img
              src={integration.logo}
              alt={integration.name + ' logo'}
              style={{
                width: integration.logoWidth ?? 64,
                height: integration.logoHeight ?? 64,
                marginBottom: 16,
              }}
              onError={(e) => {
                if (integration.logoFallback) {
                  e.target.onerror = null;
                  e.target.src = integration.logoFallback;
                }
              }}
            />
            <div style={{ fontSize: 15, color: '#555', textAlign: 'center', marginBottom: 20, minHeight: 48 }}>{integration.description}</div>
            <button
              onClick={() => handleSettings(integration.onSettings)}
              style={{ padding: '8px 24px', fontSize: 16, borderRadius: 6, border: 'none', background: 'var(--primary-color, #1976d2)', color: '#fff', cursor: 'pointer' }}
            >
              Settings
            </button>
          </div>
        ))}
      </div>
      {modalOpen && currentProvider === 'zohodesk' && (
        <ZohoDeskModal
          open={modalOpen}
          onClose={() => {
            setModalOpen(false);
            setCurrentProvider(null);
          }}
          productName={productName}
          resellerBaseUrl={reseller?.baseUrl}
        />
      )}
      {deskproModalOpen && (
        <DeskProModal
          open={deskproModalOpen}
          onClose={() => {
            setDeskproModalOpen(false);
            setCurrentProvider(null);
          }}
          tenantId={tenantId}
          productName={productName}
        />
      )}
      {hubspotModalOpen && (
        <HubSpotModal
          open={hubspotModalOpen}
          onClose={() => {
            setHubspotModalOpen(false);
            setCurrentProvider(null);
          }}
          productName={productName}
          resellerBaseUrl={reseller?.baseUrl}
        />
      )}
      {salesforceModalOpen && (
        <SalesforceModal
          open={salesforceModalOpen}
          onClose={() => {
            setSalesforceModalOpen(false);
            setCurrentProvider(null);
          }}
          productName={productName}
          resellerBaseUrl={reseller?.baseUrl}
        />
      )}
      {chattitudeModalOpen && (
        <ChattitudeModal
          open={chattitudeModalOpen}
          onClose={() => {
            setChattitudeModalOpen(false);
            setCurrentProvider(null);
          }}
          productName={productName}
        />
      )}
      {statusIoModalOpen && (
        <StatusIoModal
          open={statusIoModalOpen}
          onClose={() => {
            setStatusIoModalOpen(false);
            setCurrentProvider(null);
          }}
        />
      )}
      {calcomModalOpen && (
        <CalcomModal
          open={calcomModalOpen}
          onClose={() => {
            setCalcomModalOpen(false);
            setCurrentProvider(null);
          }}
          productName={productName}
          resellerBaseUrl={reseller?.baseUrl}
        />
      )}
    </div>
  );
};

export default Tools;
